module.exports = __webpack_public_path__ + "img/password.75c46804.svg";